import React, { Fragment } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { PARTNER_CONTENT_STORY_TEMPLATE } from "../../../constants";
import { StoryCard } from "./StoryCard";

import "./three-col-nine-var-one.m.css";

export const OtherStories = ({
  showStorySeparator,
  otherStories,
  showTimeStamp,
  showReadTime,
  isFirstSet,
  sectionSlug,
}) => {
  return (
    <>
      {otherStories.map((story, index) => {
        const sponsor = get(story, ["metadata", "sponsored-by"], null);
        const imageUrl =
          get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"]) ||
          get(story, ["hero-image-s3-key"]);
        const showImageThumbnail = (story["story-template"] === PARTNER_CONTENT_STORY_TEMPLATE || sponsor) && imageUrl;
        const isSecondStory = isFirstSet && index === 0;
        return (
          <Fragment key={index}>
            <StoryCard
              key={index}
              story={story}
              showTimeStamp={showTimeStamp}
              showReadTime={showReadTime}
              showImageThumbnail={isSecondStory || showImageThumbnail}
              sectionSlug={sectionSlug}
            />
            {showStorySeparator && index !== otherStories.length - 1 && <div styleName="divider"></div>}
          </Fragment>
        );
      })}
    </>
  );
};

OtherStories.propTypes = {
  otherStories: PropTypes.array.isRequired,
  showStorySeparator: PropTypes.bool,
  showTimeStamp: PropTypes.bool,
  showReadTime: PropTypes.bool,
  isFirstSet: PropTypes.bool,
  sectionSlug: PropTypes.string,
};
